import { render, staticRenderFns } from "./PurchaseLegalReport.vue?vue&type=template&id=03753209"
import script from "./PurchaseLegalReport.vue?vue&type=script&lang=js"
export * from "./PurchaseLegalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports